import { render, staticRenderFns } from "./ContactsModal.vue?vue&type=template&id=5e6baff9&lang=pug&"
import script from "./ContactsModal.vue?vue&type=script&lang=ts&"
export * from "./ContactsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports